import React, {Component} from 'react';
import {Row} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import Panel from '../../../../src/components/Panel'
import * as environment from "../../../modules/environment";
import EquipmentTableForOrdering from './EquipmentTableForOrdering'


class EquipmentCategories extends Component {

    constructor(props) {
        super(props);
        this.state = {
            warning: '',
            error: false,
            saved: false,
            selectedID: 0
        }
    }

    showTable = (groupId) => {
        if (groupId === this.state.selectedID) {
            this.setState({selectedID: 0});
        } else {
            this.setState({selectedID: groupId});
        }
    };

    render() {

        let data = [];

        if(this.state.selectedID !== 0) {
            let tmp = this.props.data.find(e => e.groupId === this.state.selectedID);
            if(tmp !== undefined) {
                data = tmp.data;
            }
        }

        return (
            <Row style={{margin: '0'}}>
                {this.state.selectedID !== 0 && <EquipmentTableForOrdering data={data} close={() => this.showTable(this.state.selectedID)}/>
                }
                {this.state.selectedID === 0 && this.props.data.map((item,index) => {

                        let logoUrl = environment.getServerBasePath() + '/equip/equip_cat_download?equipCatID=' + item.groupId;

                        return (<Panel md={12} lg={6} xl={3} xs={12}>
                            <div className="dashboard__product" style={{cursor: 'pointer'}} onClick={() => this.showTable(item.groupId)}>
                                <div className="dashboard__product-img">
                                    <img src={logoUrl} alt="" />
                                </div>
                                <h5 className="bold-text dashboard__product-title">{item.groupName}</h5>
                                {/*<h5 className="subhead dashboard__product-subhead">Knowledge nay estimable questions repulsive daughters
                                    boy.
                                </h5>*/}
                                {/*<p><a href="/">View in the item list</a></p>*/}
                            </div>
                        </Panel>)

                    })}
            </Row>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData,
        data: state.equipment.data.equip,
    };
};

export default withRouter(connect(mapStateToProps)(EquipmentCategories))